import {useState} from "react";
import styled from "styled-components";
import {SearchFieldV5} from "../../input/search/SearchFieldV5";
import {IconButtonStyled, IconButtonV5} from "../../interaction/IconButtonV5";
import type {Report} from "../../../../data/models/Report";
import type {View} from "../../../../data/models/View";
import {baseDistance, fontSize, fontWeight} from "../../styles/styles";
import {colorPalette} from "../../styles/colorPalette";
import {iconSet, isDefaultViewNavigationIcon} from "./ViewIconLibrary";

interface IconPanelProps {
	readonly view?: View | Report;
	readonly onIconClick?: (iconName: string) => void;
}

export const IconPanelV5 = (props: IconPanelProps) => {
	const {view, onIconClick} = props;
	const [search, setSearch] = useState<string>("");

	const onSearchChange = (value: string) => {
		setSearch(value);
	};

	const iconName = view?.additionalDetails?.navigationPanelData?.icon;
	const IconName = isDefaultViewNavigationIcon(iconName) ? "Default" : iconName;

	const filteredIcons = iconSet.filter((iconItem) => iconItem.label.toLowerCase().includes(search.toLowerCase()));

	return (
		<ViewsIconPanelStyled>
			<p>Icon</p>
			<div className="colorPlatte">
				<SearchFieldV5
					placeholder="Find Icon"
					className="findInput"
					value={search}
					onInput={onSearchChange}
				/>
				{filteredIcons.length > 0 ? (
					<div className="icon-grid">
						{filteredIcons.map((iconItem) => (
							<IconButtonV5
								key={iconItem.label}
								IconComponent={iconItem.IconComponent}
								onClick={() => onIconClick(iconItem.label)}
								isActive={IconName === iconItem.label}
								title={iconItem.label}
							/>
						))}
					</div>
				) : (
					<div className="empty-message">No matching results found</div>
				)}
			</div>
		</ViewsIconPanelStyled>
	);
};

const ViewsIconPanelStyled = styled.div`
	width: 274px;
	margin-top: ${baseDistance.md};
	margin-bottom: ${baseDistance.sm};

	> p {
		font-size: ${fontSize.md};
		font-weight: ${fontWeight.bold};
	}

	.colorPlatte {
		margin-top: ${baseDistance.sm};
		display: flex;
		flex-direction: column;
		gap: ${baseDistance.sm};

		> p {
			font-size: ${fontSize.sm};
			color: ${colorPalette.gray.c700Dark};
			text-decoration: underline;
		}

		${IconButtonStyled} {
			svg {
				width: 16px;
				height: 16px;
			}

			&.isActive {
				background-color: ${colorPalette.primary.c200Light};

				svg path {
					stroke: ${colorPalette.primary.c500Primary};
				}
			}
		}
	}

	.icon-grid {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 7px;
		justify-content: start;
		align-content: start;
		justify-items: start;
		align-items: start;
		height: 120px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.empty-message {
		height: 120px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		font-size: var(--font-sm); /* or ${fontSize.sm} if using styled-components */
		color: #888;
	}
`;
